<template>
	<!--Beginning of profile sheet-->
	<v-sheet class="overflow-auto pb-10" :width="profilePageWidth" :height="profilePageHeight">
		<div class="container pb-1">
			<section class="section1 clearfix">
				<v-card>
					<div class="pa-1">
						<div class="row grid clearfix">
							<div class="col2 first">
								<v-card-actions class="float-right">
									<v-btn class="blue" raised outlined>Follow</v-btn>
								</v-card-actions>
								<v-card-text class="pt-2">
									<div class="float-left pr-2" slot="activator">
										<v-avatar size="150" v-ripple v-if="profileData?.profile.profile_image === ''"
											class="grey lighten-3">
											<v-icon>mdi-camera</v-icon>
										</v-avatar>
										<v-avatar v-else size="130" v-ripple class="v-img">
											<v-img :src="profileData?.profile.profile_image" alt="avatar"></v-img>
										</v-avatar>
									</div>
									<h2 class="black--text">{{ user.first_name }} {{ user.last_name }}
										<v-dialog v-model="dialog" width="500" persistent>
											<template v-slot:activator="{ on, attrs }">
												<v-btn small depressed color="transparent" class="pa-0" v-bind="attrs"
													v-on="on">
													<v-icon class="grey--text">mdi-pencil-outline</v-icon>
												</v-btn>
											</template>
											<v-card>
												<v-card-title class="text-h5 grey lighten-2">
													Update Profile image and description
												</v-card-title>
												<v-file-input class="pr-4 pl-4"
													accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera"
													label="Upload Profile Pic" v-model="uploadFile"></v-file-input>
												<v-textarea outlined class="pl-12 pr-4"
													placeholder="Update profile description here."
													v-model="description">
												</v-textarea>

												<v-text-field class="pl-12 pr-4" label="Website Link Here"
													placeholder="Placeholder" v-model="websiteLink" solo></v-text-field>
												<v-divider></v-divider>
												<v-card-actions>
													<v-spacer></v-spacer>
													<v-btn color="primary" text @click="handleUpdateProfile"
														:disabled="isLoading">
														Save
													</v-btn>
													<v-snackbar v-model="snackbar" :timeout="timeout" shaped
														color="success">
														Profile Successfully Updated
													</v-snackbar>
													<v-btn color="blue darken-1" text @click="dialog = false">
														Close
													</v-btn>
												</v-card-actions>
											</v-card>
										</v-dialog>
									</h2>
									{{ profileData?.profile.description }}
									<br />
									<p class="pr-10 float-left"><a :href="''+ profileData?.profile.website_link" target="_blank">{{profileData?.profile.website_link}}</a></p>
								</v-card-text>
							</div>
							<div class="col2 last">
								<div class="grid clearfix">
									<div class="col3 first">
										<h1>694</h1>
										<span>Following</span>
									</div>
									<div class="col3">
										<h1>452</h1>
										<span>Likes</span>
									</div>
									<div class="col3 last">
										<h1>1207</h1>
										<span>Bookmarks</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-card>
			</section>
			<section class="section2 pt-3 clearfix">
				<div class="row2tab clearfix">
					<v-tabs v-model="tab" color="deep-purple-accent-4" align-tabs="center" class="elevation-6">
						<li><v-tab><v-icon color="red">mdi-radiobox-marked</v-icon>Pings </v-tab></li>
						<li><v-tab><v-icon color="primary">mdi-hard-hat</v-icon>My Projects</v-tab></li>
						<li><v-tab><v-icon color="primary">mdi-notebook</v-icon>Planner </v-tab> </li>
						<li><v-tab><v-icon color="primary">mdi-calendar-check</v-icon>Task </v-tab> </li>
						<li><v-tab><v-icon color="primary">mdi-selection-marker</v-icon>Reping </v-tab> </li>
						<v-tab-item>
							<v-row class="pt-2 pl-2 pr-2 pb-2">
								<profilePost v-for="post in profileData?.posts" :key="post.id" :post="post"
									@update-post-event="handleUpdatePost" @delete-post-event="handleDeletePost" />
							</v-row>
						</v-tab-item>
						<!--Second Tab -->
						<v-tab-item>
							<div class="pa-3">
								Nebucanazzar: Ship Building Project
								<v-progress-linear v-model="power" color="amber" height="25"></v-progress-linear>
								<br>
								Sirius Technology: Space Technology
								<v-progress-linear v-model="skill" color="blue-grey" height="25">
									<template v-slot:default="{ value }">
										<strong>{{ Math.ceil(value) }}%</strong>
									</template>
								</v-progress-linear>
								<br>
								Sawlid: Heavy Mechanics Technology
								<v-progress-linear v-model="knowledge" height="25">
									<strong>{{ Math.ceil(knowledge) }}%</strong>
								</v-progress-linear>
							</div>
						</v-tab-item>
						<v-tab-item>
							<!--Third tab-->
							<v-row class="fill-height">
								<v-col>
									<v-sheet height="64">
										<v-toolbar flat>
											<v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
												Today
											</v-btn>
											<v-btn fab text small color="grey darken-2" @click="prev">
												<v-icon small>
													mdi-chevron-left
												</v-icon>
											</v-btn>
											<v-btn fab text small color="grey darken-2" @click="next">
												<v-icon small>
													mdi-chevron-right
												</v-icon>
											</v-btn>
											<v-toolbar-title v-if="$refs.calendar">
												{{ $refs.calendar.title }}
											</v-toolbar-title>
											<v-spacer></v-spacer>
											<v-menu bottom right>
												<template v-slot:activator="{ on, attrs }">
													<v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
														<span>{{ typeToLabel[type] }}</span>
														<v-icon right>
															mdi-menu-down
														</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item @click="type = 'day'">
														<v-list-item-title>Day</v-list-item-title>
													</v-list-item>
													<v-list-item @click="type = 'week'">
														<v-list-item-title>Week</v-list-item-title>
													</v-list-item>
													<v-list-item @click="type = 'month'">
														<v-list-item-title>Month</v-list-item-title>
													</v-list-item>
													<v-list-item @click="type = '4day'">
														<v-list-item-title>4 days</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</v-toolbar>
									</v-sheet>
									<v-sheet height="600">
										<v-calendar ref="calendar" v-model="focus" color="primary" :events="events"
											:event-color="getEventColor" :type="type" @click:event="showEvent"
											@click:more="viewDay" @click:date="viewDay"
											@change="updateRange"></v-calendar>
										<v-menu v-model="selectedOpen" :close-on-content-click="false"
											:activator="selectedElement" offset-x>
											<v-card color="grey lighten-4" min-width="350px" flat>
												<v-toolbar :color="selectedEvent.color" dark>
													<v-btn icon>
														<v-icon>mdi-pencil</v-icon>
													</v-btn>
													<v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
													<v-spacer></v-spacer>
													<v-btn icon>
														<v-icon>mdi-heart</v-icon>
													</v-btn>
													<v-btn icon>
														<v-icon>mdi-dots-vertical</v-icon>
													</v-btn>
												</v-toolbar>
												<v-card-text>
													<span v-html="selectedEvent.details"></span>
												</v-card-text>
												<v-card-actions>
													<v-btn text color="secondary" @click="selectedOpen = false">
														Cancel
													</v-btn>
												</v-card-actions>
											</v-card>
										</v-menu>
									</v-sheet>
								</v-col>
							</v-row>
						</v-tab-item>
						<!--End of third tab-->
						<v-tab-item>
							<v-text-field v-model="newTask" label="Type a task and enter to Create a task." solo
								@keydown.enter="create">
								<template v-slot:append>
									<v-fade-transition>
										<v-icon v-if="newTask" @click="create">
											mdi-plus-circle
										</v-icon>
									</v-fade-transition>
								</template>
							</v-text-field>
							<h2 class="text-h4 success--text pl-4">
								Tasks:&nbsp;
								<v-fade-transition leave-absolute>
									<span :key="`tasks-${tasks.length}`">
										{{ tasks.length }} (example)
									</span>
								</v-fade-transition>
							</h2>
							<v-divider class="mt-4"></v-divider>
							<v-row class="my-1" align="center">
								<strong class="mx-4 info--text text--darken-2">
									Remaining: {{ remainingTasks }}
								</strong>

								<v-divider vertical></v-divider>

								<strong class="mx-4 success--text text--darken-2">
									Completed: {{ completedTasks }}
								</strong>
								<v-progress-circular :value="progress" class="mr-2" color="red"></v-progress-circular>
							</v-row>
							<v-divider class="mb-4"></v-divider>
							<v-card v-if="tasks.length > 0">
								<v-slide-y-transition class="py-0" group tag="v-list">
									<template v-for="(task, i) in tasks">
										<div v-if="i !== 0" :key="i">
											<v-divider></v-divider>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox v-model="task.done"
														:color="task.done && 'grey' || 'primary'">
														<template v-slot:label>
															<div :class="task.done && 'grey--text' || 'primary--text'"
																class="ml-4" v-text="task.text"></div>
														</template>
													</v-checkbox>
												</v-list-item-action>
												<v-spacer></v-spacer>
												<v-scroll-x-transition>
													<v-icon v-if="task.done" color="success">
														mdi-check
													</v-icon>
												</v-scroll-x-transition>
											</v-list-item>
										</div>

									</template>
								</v-slide-y-transition>
							</v-card>
						</v-tab-item>
						<!--End of fourth Tab-->
						<v-tab-item>
							You have no Repings as yet.
						</v-tab-item>
					</v-tabs>
				</div>
			</section>
		</div>
	</v-sheet>
</template>
<!------------------------------>
<!--End of sheet profile-->

<script>
import countries from '../countries'
import { mapGetters, mapState } from 'vuex'
import profilePost from './profilePost'
import axios from 'axios'
import { apiUrl } from '../config';
export default {
	data: () => ({
		// Some variables are for the "My Projects feature"
		API_URL: apiUrl,
		props: "",
		tab: "",
		profileData: null,
		snackbar: false,
		timeout: 3000,
		skill: 20,
		alertDialog: false,
		dialog: false,
		knowledge: 33,
		power: 78,
		loading: false,
		isLoading: false,
		countries: [],
		//uploadLocation: "",
		editPost: false,

		// For "Task" feature (not implemented as yet)
		tasks: [
			{
				done: false,
				text: 'Orientation',
			},
			{
				done: false,
				text: 'Step 1: Introduction to Company norms',
			},
			{
				done: false,
				text: 'Step 2: What we expect from participants',
			},
			{
				done: false,
				text: 'Step 3: Final thoughts.',
			},],
		newTask: null,
		sheet: false,
		message4: '',
		isHovering: false,
		focus: '',
		type: 'month',
		typeToLabel: {
			month: 'Month',
			week: 'Week',
			day: 'Day',
			'4day': '4 Days',
		},
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		events: [],
		colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
		names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
		uploadFile: null,
		description: "",
		websiteLink: "",
	}),
	components: {
		profilePost,
	},

	props: {
		// Past article fuction as array from Globe.vue
		//
		articles: Array,
	},
	methods: {
		// Handle delete post function
		//
		async handleDeletePost(postId) {
			console.log('post id from profile page handle delete', postId)
			const isSuccess = await this.deletePostFunc(postId)
			if (isSuccess) {
				await this.getProfileData()
			}
		},
		// Sync delete post function
		//
		async deletePostFunc(postId) {

			try {
				let user = localStorage.getItem('user')
				user = JSON.parse(user)

				const authToken = 'Bearer ' + user['access'];

				console.log(authToken)


				const response = await axios.delete(`${this.API_URL}posts/${postId}/`, {
					headers: {
						'Authorization': authToken,

					},
				})

				console.log(response)
				if (response.status === 204) {
					return true; // Success
				} else {
					console.error('Unexpected status code:', response.status);
					return false; // Not successful
				}
			} catch (error) {
				console.error('Error creating business idea:', error);
				return false; // Failure
			}


		},
		// Handle Updated post function
		//
		async handleUpdatePost(postId, postData) {
			console.log('post id from profile page', postId)
			const isSuccess = await this.updatePostFunc(postId, postData)
			if (isSuccess) {
				await this.getProfileData()
			}
		},
		// Update post function.
		//
		async updatePostFunc(postId, formData) {
			try {
				console.log(formData)
				let user = localStorage.getItem('user')
				user = JSON.parse(user)

				const authToken = 'Bearer ' + user['access'];

				console.log(authToken)


				const response = await axios.patch(`${this.API_URL}posts/${postId}/`, formData, {
					headers: {
						'Authorization': authToken,
						'Content-Type': 'multipart/form-data'
					},
				})

				console.log(response)

				if (response.status === 200) {
					return true; // Success
				} else {
					console.error('Unexpected status code:', response.status);
					return false; // Not successful
				}
			} catch (error) {
				console.error('Error creating business idea:', error);
				return false; // Failure
			}


		},
		// Sync profile function
		//
		async updateProfileFunc(formData) {


			try {
				this.isLoading = true
				console.log(formData)
				let user = localStorage.getItem('user')
				user = JSON.parse(user)

				const authToken = 'Bearer ' + user['access'];

				console.log(authToken)

				const response = await axios.put(`${this.API_URL}users/update-profile/`, formData, {
					headers: {
						'Authorization': authToken,
						'Content-Type': 'multipart/form-data'
					},
				})

				console.log('API Response:', response);


				if (response.status === 200) {
					return true; // Success
				} else {
					console.error('Unexpected status code:', response.status);
					return false; // Not successful
				}
			} catch (error) {
				console.error('Error creating business idea:', error);
				return false; // Failure
			}



		},
		// Update profile function
		//
		async handleUpdateProfile() {
			console.log('save button pressed')
			this.isLoading = false
			if (this.uploadFile || this.description || this.websiteLink) {
				const profileData = {
					description: this.description,
					website_link: this.websiteLink,
					profile_image: this.uploadFile
				}

				console.log('profileData from profilePage', profileData)

				const formData = new FormData();
				formData.append('description', this.description);
				formData.append('website_link', this.websiteLink);

				if (this.uploadFile !== null) {
					formData.append('profile_image', this.uploadFile);

				}

				this.isLoading = true

				const isSuccess = await this.updateProfileFunc(formData)
				this.isLoading = false

				this.snackbar = true
				this.dialog = false

				if (isSuccess) {
					await this.getProfileData()

					this.$emit('fetch-user-data');
				}

			}
		},

		reserve() { },
		// Planner methods
		//
		viewDay({ date }) {
			this.focus = date
			this.type = 'day'
		},
		getEventColor(event) {
			return event.color
		},
		setToday() {
			this.focus = ''
		},
		prev() {
			this.$refs.calendar.prev()
		},
		next() {
			this.$refs.calendar.next()
		},
		showEvent({ nativeEvent, event }) {
			const open = () => {
				this.selectedEvent = event
				this.selectedElement = nativeEvent.target
				requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
			}

			if (this.selectedOpen) {
				this.selectedOpen = false
				requestAnimationFrame(() => requestAnimationFrame(() => open()))
			} else {
				open()
			}

			nativeEvent.stopPropagation()
		},
		// This function is for the calender feature inside the profilePage 
		//
		updateRange({ start, end }) {
			const events = []

			const min = new Date(`${start.date}T00:00:00`)
			const max = new Date(`${end.date}T23:59:59`)
			const days = (max.getTime() - min.getTime()) / 86400000
			const eventCount = this.rnd(days, days + 20)

			for (let i = 0; i < eventCount; i++) {
				const allDay = this.rnd(0, 3) === 0
				const firstTimestamp = this.rnd(min.getTime(), max.getTime())
				const first = new Date(firstTimestamp - (firstTimestamp % 900000))
				const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
				const second = new Date(first.getTime() + secondTimestamp)

				events.push({
					name: this.names[this.rnd(0, this.names.length - 1)],
					start: first,
					end: second,
					color: this.colors[this.rnd(0, this.colors.length - 1)],
					timed: !allDay,
				})
			}

			this.events = events
		},
		rnd(a, b) {
			return Math.floor((b - a + 1) * Math.random()) + a
		},
		//loading feature for delete button.
		async remove() {
			this.loading = true

			await new Promise(resolve => setTimeout(resolve, 3000))

			this.loading = false
		},
		// get profile data feature.
		//
		async getProfileData() {
			let user = localStorage.getItem('user')
			user = JSON.parse(user)

			const authToken = 'Bearer ' + user['access'];
			console.log(authToken)

			const response = await axios.get(`${this.API_URL}users/current-user/`, {
				headers: {
					'Authorization': authToken,
				},
			})
			console.log(response.data)

			this.profileData = response.data

			this.description = this.profileData.profile.description
			this.websiteLink = this.profileData.profile.website_link

		},
		// Create a task in profile page
		create() {
			this.tasks.push({
				done: false,
				text: this.newTask,
			})

			this.newTask = null
		}
	},
	created() {
		this.getProfileData()
	},
	mounted() {
		this.countries = countries
		// this.getProfileData()
	},
	computed: {
		// Profile page dimension based on screen size
		//
		profilePageHeight() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs': return 690;
				case 'sm': return 690;
				case 'md': return 690;
				case 'lg': return 690;
				case 'xl': return 1600;
				default: return 690; // Default value if no case matches
			}
		},
		profilePageWidth() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs': return 545;
				case 'sm': return 780;
				case 'md': return 1200;
				case 'lg': return 1200;
				case 'xl': return 1600;
				default: return 1200; // Default value if no case matches
			}
		},
		// profilePageHeight() {
		// 	switch (this.$vuetify.breakpoint.name) {
		// 		case 'xs': return 690
		// 		case 'sm': return 690
		// 		case 'md': return 690
		// 		case 'lg': return 690
		// 		case 'xl': return 1600
		// 	}
		// },
		// profilePageWidth() {
		// 	switch (this.$vuetify.breakpoint.name) {
		// 		case 'xs': return 545
		// 		case 'sm': return 780
		// 		case 'md': return 1200
		// 		case 'lg': return 1200
		// 		case 'xl': return 1600
		// 	}
		// },
		// Planner 
		//
		//this.$refs.calendar.checkChange(),
		...mapState(['user']),
		...mapGetters({ user: "auth/user" }),

		// Task computed methods
		//
		completedTasks() {
			return this.tasks.filter(task => task.done).length
		},
		progress() {
			return this.completedTasks / this.tasks.length * 100
		},
		remainingTasks() {
			return this.tasks.length - this.completedTasks
		},

	},
}
</script>